import React from "react";
import freeparking from '../assests/parking.webp';
import foodcourt from '../assests/food.webp';
import bar from '../assests/bar.webp';
import room from '../assests/room.webp';

const features = [
  {
    image: freeparking, // Replace with actual image path
    title: "Free Parking",
    description: "Secure and convenient parking available for all guests.",
  },
  {
    image: foodcourt, // Replace with actual image path
    title: "Food Court",
    description: "Enjoy delicious meals and snacks in our elegant food court.",
  },
  {
    image: bar, // Replace with actual image path
    title: "Bar",
    description: "Relax at our fully-stocked bar with premium drinks.",
  },
  {
    image: room, // Replace with actual image path
    title: "Hotel Rooms",
    description: "Comfortable rooms available for a luxurious overnight stay.",
  },
];

const LuxuryGrandCinemaz = () => {
  return (
    <section className="bg-gradient-to-b from-red-950 to-blue-950 text-white pt-24 pb-20 px-6 md:px-20 overflow-hidden relative">
      {/* Background luxury elements */}
      <div className="absolute inset-0 overflow-hidden opacity-10">
        <div className="absolute w-64 h-64 bg-yellow-500 rounded-full blur-3xl -top-20 -left-20"></div>
        <div className="absolute w-96 h-96 bg-yellow-500 rounded-full blur-3xl -bottom-40 -right-20"></div>
      </div>

      {/* Hero content */}
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="h-1 w-24 bg-yellow-500 rounded-full"></div>
          </div>
          <h1 className="text-6xl font-bold text-white mb-6 tracking-tight">
            <span className="text-yellow-500">Grand Cinemaz</span> Experience
          </h1>
          <p className="text-3xl font-light text-gray-300 max-w-3xl mx-auto mb-8">
            Where Luxury Meets Cinema
          </p>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Indulge in the ultimate cinematic journey with our exclusive
            amenities and unparalleled service. More than a movie—it's an
            experience crafted for connoisseurs.
          </p>
        </div>

        {/* Features grid with staggered animation effect */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((item, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-red-900/40 to-blue-900/40 p-8 rounded-2xl shadow-xl border border-blue-900 hover:border-yellow-500/30 transition-all duration-300"
            >
              <div className="mb-6 transform group-hover:scale-110 transition-transform duration-300">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-40 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-semibold mb-3 text-white group-hover:text-yellow-500 transition-colors duration-300">
                {item.title}
              </h3>
              <p className="text-gray-300 group-hover:text-gray-200 transition-colors duration-300">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Testimonial section */}
      </div>
    </section>
  );
};

export default LuxuryGrandCinemaz;
